export default __webpack_public_path__ + "static/media/play-white.e85b2db1.svg";